var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"caption pa-0 ma-0",staticStyle:{"font-size":"10px !important"}},[_vm._v(_vm._s(_vm.captionText))])}
var staticRenderFns = []

export { render, staticRenderFns }